var FontWeights;
(function (FontWeights) {
    FontWeights[FontWeights["Thin"] = 100] = "Thin";
    FontWeights[FontWeights["Light"] = 300] = "Light";
    FontWeights[FontWeights["Regular"] = 400] = "Regular";
    FontWeights[FontWeights["Medium"] = 500] = "Medium";
    FontWeights[FontWeights["Bold"] = 700] = "Bold";
    FontWeights[FontWeights["Heavy"] = 900] = "Heavy";
})(FontWeights || (FontWeights = {}));
export default FontWeights;
//# sourceMappingURL=fontWeights.js.map